// extracted by mini-css-extract-plugin
export default {"prevArrow":"home_prevArrow__R2g8L","nextArrow":"home_nextArrow__qslU0"};